import { render, staticRenderFns } from "./HomeViewTask.vue?vue&type=template&id=4af82fa6"
import script from "./HomeViewTask.vue?vue&type=script&lang=js"
export * from "./HomeViewTask.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports